import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { Address } from '@app/modules/applicant-tracker/interfaces/address.interface';
import { isEmpty } from 'lodash-es';

@Component({
    selector: 'app-address-search',
    templateUrl: './address-search.template.html',
    styleUrls: ['./address-search.style.scss'],
})
export class AddressSearchComponent implements OnInit {
    @Input() jobPosting: JobPosting;

    public addressToRender = '';
    private addressSearchElement: HTMLInputElement | null = null;
    private address: Address;

    constructor(private readonly changeDetectionRef: ChangeDetectorRef) {}

    async ngOnInit(): Promise<void> {
        const addressNode = document.getElementById('address-search-capable');
        if (isEmpty(addressNode)) {
            return;
        }
        this.addressSearchElement = addressNode as HTMLInputElement;
        this.address = this.jobPosting.address;
        this.initAddressToRender();
    }

    handleAddressChange(address: Address): void {
        this.resetAddressValues();
        this.address = address;
        this.jobPosting.address = this.address;
        this.initAddressToRender();
    }

    public handleBlur(): void {
        if (
            isEmpty(this.addressSearchElement) ||
            isEmpty(this.addressSearchElement.value) ||
            this.addressSearchElement.value === this.addressToRender
        ) {
            return;
        }

        if (this.addressSearchElement.value !== this.addressToRender) {
            this.addressSearchElement.value = this.addressToRender;
        }
    }

    public handleChange(value: string): void {
        if (isEmpty(value)) {
            //Handles case where user deletes the previously selected address
            //in this particular case don't reset all values (keeps city, region and country unchanged)
            this.resetAddressValues(false);
            this.jobPosting.address = this.address;
        }
    }

    private initAddressToRender(): void {
        this.addressToRender = '';
        this.changeDetectionRef.detectChanges();
        if (!this.address) {
            return;
        }
        if (this.address.line1) {
            this.addressToRender = this.address.line1;
        }
        if (this.address.line2) {
            this.addressToRender += ' ' + this.address.line2;
        }
    }

    private resetAddressValues(allValues = true): void {
        this.address.line1 = null;
        this.address.line2 = null;
        this.address.postalCode = null;
        this.address.latitude = null;
        this.address.longitude = null;
        if (allValues) {
            this.address.city = null;
            this.address.region = null;
            this.address.country = null;
        }
    }
}
